import { motion } from 'framer-motion'
import React from 'react'
import Ieee_banner from '../Slider/Ieee_banner'
import { Link } from 'react-router-dom'

function Submission() {
  return (
    <div className="container my-5">

        <motion.div className="card shadow-lg" style={{ overflow: 'hidden', background: 'None' }}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.6, ease: 'easeOut' }}>

                <div className="card-body">
                    <h1 className="card-title text-center text-danger"><strong>Paper Submission</strong></h1>
                    <p className="card-text my-4" style={{textAlign:"justify"}}>NETCRYPT 2026 is dedicated to fostering high-quality research in the field of Computational Sciences. This conference serves as a platform for sharing information, introducing innovative technologies and advancements, and exploring future directions, strategies, and priorities within this domain. NETCRYPT 2026 undoubtedly gathers influential thought leaders to engage in discussions and deliberations on the most critical issues, delivering timely insights across various sectors and exemplary practices. The exchange of ideas in areas of interest lays the groundwork for future collaborations on a global scale. Among the key advantages of attending this conference is the opportunity to stay updated on the latest developments in technology, which is essential for academic sustainability. The conference ensures participants are well-informed about the most recent discoveries and advancements in the field.</p>

                    <h3 className="card-title text-danger my-3">Steps for Submission</h3>
                    <ul className="" style={{textAlign:"justify"}}>
                        <li className="card-text">Create your CMT microsoft account</li>
                        <li className="card-text">Login through your CMT microsoft account</li>
                        <li className="card-text">Search for NETCRYPT2026 / Click on the below link to redirect <br/>
                            <a href="https://cmt3.research.microsoft.com/NETCRYPT2026" type="button" class="btn btn-primary border-0 my-3" target="_blank" style={{background:"rgb(0,126,123)"}}>NETCRYPT 2026</a>
                        </li>
                        <li className="card-text">Submit your paper.</li>
                        <li className="card-text">Wait for acceptance.</li>
                    </ul>
                </div>


                </motion.div>

                <div className="d-flex justify-content-center align-items-center my-5">
                  <Link to="/guidelines" type="button" class="btn btn-outline-danger"> <h3>Instructions and Guidelines for Authors</h3> </Link>
                </div>

                <Ieee_banner />

               

                
    </div>
  )
}

export default Submission